import { getMockDataByKeys } from "./mock";

export const NOTIFY = {
  name: "notify",
  uuid: 0x7401,
  properties: ["read", "write", "notify"],
};

export function generateMockMAABSNotifyData(): DomianControl.MAABSNotifyData {
  const data = getMockDataByKeys([
    "UIRx_FLWhlSpd_BCh1",
    "UIRx_FRWhlSpd_BCh1",
    "UIRx_MotTq_FA",
    "UIRx_MotTq_RA",
    "UIRx_RLWhlSpd_BCh1",
    "UIRx_RRWhlSpd_BCh1",
    "UIRx_VehSpd",
    "UIRx_ACULongdAcc",
    "UIRx_WhlBrkTqAct_FL_BCh1",
    "UIRx_WhlBrkTqAct_FR_BCh1",
    "UIRx_WhlBrkTqAct_RL_BCh1",
    "UIRx_WhlBrkTqAct_RR_BCh1",
  ]);
  return data;
}
